import {
  IndividualPersonalDetails,
  IndividualAssignments,
  IndividualSponsorships,
  IndividualNotifications
} from '@/components/IndividualSettings'

import type { TabType } from './types'

const organizationIndividualTabs: TabType[] = [
  {
    url: 'details',
    label: 'Personal Details',
    component: IndividualPersonalDetails,
  },
  {
    url: 'assignments',
    label: 'Assignments',
    component: IndividualAssignments,
  },
  {
    url: 'sponsorships',
    label: 'Sponsorships',
    component: IndividualSponsorships,
  },
  {
    url: 'notifications',
    label: 'Notifications',
    component: IndividualNotifications,
  }
]


export default organizationIndividualTabs
